<div id="track-orders-component" class="container-fluid my-5">
	<div class="hmf-grid">
		<div id="track-orders" class="hmf-col hmf-span-10 hmf-offset-1">
			<div class="row">
				<h1 class="track-orders__title col-lg-12 mt-5" id="track-order-heading">
					Track Your Order
				</h1>
			</div>

			<div class="row">
				<div class="col-lg-12 mt-5">
					<p class="track-orders__headline col-lg-12 mb-1">
						Tracking your order is fast and simple!
					</p>
					<p class="track-orders__instruction col-lg-12">
						Simply enter your order number and {{ trackOrderByEmailEnabled ? 'email address' : 'billing ZIP/postal code' }} to track your new gear.
					</p>
				</div>
			</div>

			<div class="hmf-mt-xl">
				<form id="track-orders-form" [formGroup]="orderTrackForm">
					<fieldset aria-labelledby="track-order-heading">
						<legend>
						<div class="hmf-grid">
							<div class="col-12 col-xl-4 hmf-pt-xs">
								<hmf-text-input
									[placeholder]="constants.fieldLabels.orderNumber"
									[error]="!!orderTrackForm.get('orderNumber')?.errors"
									formControlName="orderNumber"
									id="order-number-input"
									class="track-orders__text">
								</hmf-text-input>
							</div>

							<div class="col-12 col-xl-4 hmf-pt-xs text-center">
								<div *ngIf="!trackOrderByEmailEnabled">
									<div *ngIf="postalCodeCountry === constants.countries.unitedStates.abbrev">
										<hmf-text-input
											[placeholder]="constants.fieldLabels.zip"
											[error]="!!orderTrackForm.get('zip')?.errors"
											formControlName="zip"
											id="zip-code-input"
											class="track-orders__text">
										</hmf-text-input>
										<hmf-button
											[variant]="'tertiary'"
											[text]="'Canadian Postal Code?'"
											[classList]="'show-canadian-postal postal-code-button'"
											(click)="showCanadianPostalCode()">
										</hmf-button>
									</div>

									<div *ngIf="postalCodeCountry === constants.countries.canada.abbrev">
										<hmf-text-input
											[placeholder]="constants.fieldLabels.canadianPostalCode"
											[error]="!!orderTrackForm.get('canadianPostal')?.errors"
											formControlName="canadianPostal"
											id="canadian-postal-code-input"
											class="track-orders__text">
										</hmf-text-input>
										<hmf-button
											[variant]="'tertiary'"
											[text]="'US Zip Code?'"
											[classList]="'show-us-zip-code postal-code-button'"
											(click)="showUSZipCode()">
										</hmf-button>
									</div>
								</div>
								<div *ngIf="trackOrderByEmailEnabled">
									<hmf-text-input
										[placeholder]="constants.fieldLabels.email"
										[error]="!!orderTrackForm.get('email')?.errors"
										[type]="'email'"
										[errorIconEnabled]="true"
										[helperText]="emailControl.hasError('email') ? 'Please enter a valid email.' : emailControl.hasError('europeanDomain') ? 'Email address not accepted.' : ''"
										formControlName="email"
										id="email-address-input"
										class="track-orders__text">
									</hmf-text-input>
								</div>

							</div>

							<div class="col-12 col-xl-4 hmf-pt-xs text-center text-xl-left" style="padding-top:2px;">

								<hmf-button
									type="submit"
									[variant]="'primary'"
									[text]="'TRACK ORDER'"
									[size]="'medium'"
									[disabled]="isSubmitDisabled() || showSpinner"
									(click)="trackOrder($event)">
								</hmf-button>
							</div>

							<div class="hmf-mt-m col-12 col-xl-8 mt-5 mt-xl-0">
								<mat-error *ngIf="errorMessage" class="track-orders__text">
									{{errorMessage}}
								</mat-error>
							</div>
						</div>
						</legend>
					</fieldset>
				</form>
			</div>
		</div>
	</div>

	<div class="row">
		<div class="col-md-12 col-xl-12 mx-auto" >
			<my-account-order-track-components-order-detail-cards *ngIf="orderDetail" [trackOrder]="true" [orderDetail]="orderDetail" [resetCheckIn]="resetCheckIn" [zipCode]="zipPostalControl.value"></my-account-order-track-components-order-detail-cards>
		</div>
	</div>
</div>
